<template>
  <div>
    <v-card>
      <v-row>
        <v-card-title class="primary--text mt-3"
          ><v-btn @click="back" class="ml-n2 primary--text" text>
            <v-icon>mdi-reply</v-icon></v-btn
          >Approval
          <span
            style="
              font-style: italic;
              font-family: Times New Roman;
              font-size: 14px;
            "
            class="text-left font-weight: 20 primary--text ml-2"
            >(Card Users Funds Approval)</span
          ></v-card-title
        >
      </v-row>
      <v-tabs v-model="tab" grow color="primary">
        <v-tab v-for="tabname in tabnames" :key="tabname">{{ tabname }}</v-tab>
      </v-tabs>
    </v-card>
    <approvefunds v-if="tab == 0" />
    <cardfunds v-if="tab == 1" />
  </div>
  <!-- <acknowledge ref="acknowledge" />

  <page ref="paymentGateway" :redirect="redirect" />-->
</template>

<script>
import approvefunds from "@/Views/Funds/approvefunds.vue";

import cardfunds from "@/Views/Funds/cardfunds.vue";

export default {
  components: {
    approvefunds,
    cardfunds,
  },
  data: () => ({
    tabnames: ["Pending", "History"],
    tab: 0,

    Individual: "",
    p50: "",
    varhtml: "",
  }),
  mounted() {
    // this.getcardreqstatus();
  },
  methods: {
    back() {
      this.$router.push("/Dashboard");
    },
  },
};
</script>

<style>
.rmclasstitle {
  color: orangered;
  font-size: 45px;
}

.rmclasssubtitle {
  color: orange;
  font-size: 15px;
}
</style>
